import {getTranspose} from "effects/midi/scales/getTranspose.js";
import MidiTrigger from "effects/midi/MidiTrigger.js";
import {s, lazy, trigger, filter} from './lang.js';

export const scale = (scaleList) => {
    return (stepData, stepNumber, time, effect) => {
        if (!stepData) {
            return filter(true);
        }
        let _trigger = effect.copyTrigger(new MidiTrigger(stepData, time, stepNumber), true);
        let _scale = lazy(scaleList, stepData, stepNumber, time, effect);
        let transpose = getTranspose(
            stepData.transpose, _scale, undefined,
            (x) => lazy(x, stepData, stepNumber, time, effect));
        
        _trigger.stepData.transpose = transpose;
        return trigger({stepData: _trigger.stepData, stepNumber, time});
    };
};
